import { DataTable, Dialog, Heading, Loader } from "@/components";
import { Button, Input, Textarea } from "@/components/ui";
import { Search } from "lucide-react";
import useProjectPlan from "./useProjectPlan";
import { cn, planStatus } from "@/lib/utils";

const ProjectPlan = () => {
  const {
    globalFilter,
    setGlobalFilter,
    columns,
    planList,
    isPlanLoading,
    selectedPlan,
    onSubmitApproval,
    showConfirmation,
    setShowConfirmation,
    reason,
    onChangeReason,
    onConfirmSubmit,
    isUpdatePending,
    isApprove,
    isApprovePlanExist
  } = useProjectPlan();

  return (
    <div>
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="" />
        </div>
        <div className="flex flex-col md:flex-row gap-4">
          {isApprovePlanExist ? <></> : <><Button onClick={onSubmitApproval(true)} disabled={!selectedPlan || isUpdatePending} className="bg-green-600 text-white hover:text-white hover:bg-green-600">
            Approve
          </Button>
          <Button onClick={onSubmitApproval(false)} disabled={!selectedPlan || isUpdatePending} className="bg-red-600 text-white hover:text-white hover:bg-red-600">
            Reject
          </Button></>}
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
        </div>
      </div>

      {/* Responsive Table */}
      {isPlanLoading ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={planList?.data?.filter((data: any) => data?.status != planStatus.draft.value) || []}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
          />
        </>
      )}
      <Dialog
        open={showConfirmation}
        setOpen={setShowConfirmation}
        title={isApprove ? "Approve Project Plan" : "Reject Project Plan"}
        onSave={onConfirmSubmit}
        saveBtnClassName={cn(isApprove ? 'bg-green-600 hover:bg-green-600' : 'bg-red-600 hover:bg-red-600', 'text-white')}
        saveText={isApprove ? "Approve" : "Reject"}
        contentClassName="lg:!max-w-[500px] lg:w-[500px]"
      >
        <div>
          {isApprove ? 
            'Are you sure you want to approve this project plan? If yes, please provide a brief reason for your approval below.' : 
            'Are you sure you want to reject this project plan? If yes, please provide a brief reason for your rejection below.'
          }
          <div className="mt-5">
            <Textarea value={reason} onChange={onChangeReason} placeholder="Enter your reason here" className="h-[300px]" />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ProjectPlan;
